<template>
  <div class="dd-l-grid dd-l-grid--category-products">
  	
    <card-filter v-if="false"></card-filter>

    <div class="dd-l-grid--category-products__container">
      <div class="dd-l-grid--category-products__header">
        <h2 class="dd-l-grid--category-products__title">{{ getTranslateString('My account') }}</h2>

        <span class="dd-m-helper--detail-row"></span>
      </div>

      <div v-if="!results.length && hasLoaded">
        <h2 class="dd-l-section--products-search__title">{{ getTranslateString('No results for') }} {{this.catName}}</h2>
        <p
          class="dd-m-helper--empty-msg has-margin"
        >{{ getTranslateString("We couldn't find any results for your search.")}}</p>
      </div>

      <loading type="banner" v-if="isLoading"></loading>

      <div v-if="results.length" class="dd-l-grid--category-products__content">
        <div class="dd-l-grid--category-products__list">
          <card-category-product v-for="(item, index) in results" :item="item" :key="index"></card-category-product>
        </div>

        <div class="dd-l-grid--category-products__bottom" v-if="hasMore">
          <vue-ladda
            button-class="dd-m-button dd-m-button--auto dd-m-button--light"
            :loading="isLoadingMore"
            v-on:click.prevent="loadMore()"
          >{{getTranslateString('View more')}}</vue-ladda>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ProductService from "../../providers/api/product-service";
import Q from "q";
import CardFilter from "../cards/card-filter";
import Loading from "../loading";
import CardCategoryProduct from "./card-category-product";

const productService = new ProductService();

export default {
  name: "category-products-content",
  components: { CardCategoryProduct, Loading, CardFilter },
  props: ["perPage", "slug", "catName"],
  data: () => {
    return {
      results: [],
      subcategories: "",
      isLoadingMore: false,
      isLoading: false,
      hasLoaded: false,
      hasMore: false,
      params: {
        categories: null,
        page: 1,
        sort: ""
      }
    };
  },
  mounted() {
    this.subscribe();
    this.getProducts();
  },
  methods: {
    getProducts() {
      const d = Q.defer();
      this.isLoading = !this.isLoadingMore;
      this.hasLoaded = false;
      if (!this.params.categories) this.params.categories = this.slug;

      const categories = `${this.params.categories},${this.subcategories}`,
        updatedParams = {
          page: this.params.page,
          categories: categories,
          sort: this.params.sort
        };

      productService
        .doGetProducts(updatedParams)
        .then(res => {
          res.data.data.map(item => {
            this.results.push(item);
            return item;
          });

          this.hasMore = res.data.pagination.links.next;
          this.hasLoaded = true;
          this.isLoading = false;

          d.resolve();
        })
        .catch(() => {
          this.isLoading = false;
          d.reject();
        });

      return d.promise;
    },
    resetParams() {
      this.params.page = 1;
      this.hasMore = true;
      this.results = [];
    },
    subscribe() {
      PubSub.subscribe("updateProductList", (msg, param) => {
        this.resetParams();

        if (param.name) {
          this.params.categories = param.name;
        } else {
          this.subcategories = param;
        }

        this.getProducts();
      });

      PubSub.subscribe("updateProductSort", (msg, param) => {
        this.resetParams();
        this.params.sort = param;
        this.getProducts();
      });
    },
    loadMore() {
      this.params.page++;
      this.isLoadingMore = true;
      this.getProducts()
        .then(() => (this.isLoadingMore = false))
        .catch(() => (this.isLoadingMore = false));
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/site/js/components/products/category-products-content.vue